import { render, staticRenderFns } from "./CoursesLevels.vue?vue&type=template&id=16466fd2"
import script from "./CoursesLevels.vue?vue&type=script&lang=js"
export * from "./CoursesLevels.vue?vue&type=script&lang=js"
import style0 from "./CoursesLevels.vue?vue&type=style&index=0&id=16466fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports